import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


const apiSlice = createSlice({
  name: "api",
  initialState: {
    spinnerStart: false,
    apiInfo: {
      isError: false,
      message: '',
      status: ''
     
    }  
  },
  reducers: {
    spinnerStart: (state, action) => {
      state.spinnerStart = true
    },  
    apiResponse: (state, action) => {
   
      state.apiInfo.isError = action.payload.isError
      state.apiInfo.message = action.payload.message
      state.apiInfo.status = action.payload.status
     // state.apiInfo.timeStamp = new Date();
     },
   
     resetApi: (state) => {
      state.spinnerStart = false;
      state.apiInfo.isError = ''
      state.apiInfo.message = ''
      state.apiInfo.status = ''
     // state.apiInfo.timeStamp = ''
    },
     spinnerEnd: (state) => {
   
      state.spinnerStart = false;
    }, 
  },
});

export const {apiResponse, spinnerStart, spinnerEnd, resetApi } = apiSlice.actions;
export default apiSlice.reducer;